import {WithdrawBlockReasonEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function withdrawBlockReasonNameFilter(reason: WithdrawBlockReasonEnum): string {
  switch (reason) {
    case WithdrawBlockReasonEnum.Bailiff: return i18n.t(LF.WithdrawBlockReasonBailiff) as string;
    case WithdrawBlockReasonEnum.MissingTaxQualification: return i18n.t(LF.WithdrawBlockReasonMissingTaxQualification) as string;
    case WithdrawBlockReasonEnum.MissingFilesAfterRegistration: return i18n.t(LF.WithdrawBlockReasonMissingFilesAfterRegistration) as string;
    case WithdrawBlockReasonEnum.ExpiredStudentCard: return i18n.t(LF.WithdrawBlockReasonExpiredStudentCard) as string;
    case WithdrawBlockReasonEnum.MissingSelfInvoicingPermission: return i18n.t(LF.WithdrawBlockReasonMissingSelfInvoicingPermission) as string;
    case WithdrawBlockReasonEnum.Inactive: return i18n.t(LF.WithdrawBlockReasonInactive) as string;
    case WithdrawBlockReasonEnum.OfficeDecision: return i18n.t(LF.WithdrawBlockReasonOfficeDecision) as string;
  }
}
